export default __webpack_public_path__ + "static/media/eye_icn.3f663bc2.svg";